import React from 'react'
import { View, ViewProps, StyleSheet } from 'react-native'

import { Font, Spacing } from '../../style'
import Text, { Level } from '../typography/text'

import Logo from './logo'

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
  },
  text: {
    fontFamily: Font.light,
  },
})

interface Config {
  [size: string]: {
    width: number
    level: Level
    letterSpacing: number
    paddingLeft: number
    margin: number
  }
}

const SizeConfig: Config = {
  XL: {
    width: 260,
    level: 5,
    letterSpacing: 6,
    paddingLeft: 6,
    margin: Spacing.XS,
  },
  L: {
    width: 180,
    level: 6,
    letterSpacing: 5,
    paddingLeft: 5,
    margin: Spacing.XS,
  },
  M: {
    width: 120,
    level: 7,
    letterSpacing: 3,
    paddingLeft: 3,
    margin: Spacing.XXS,
  },
  S: {
    width: 60,
    level: 7,
    letterSpacing: 3,
    paddingLeft: 3,
    margin: 0,
  },
}

export type Size = keyof typeof SizeConfig
export const Sizes = Object.keys(SizeConfig) as Size[]

export interface Props extends ViewProps {
  size?: Size
  payoff?: string
}
const BrandingIdentity = (props: Props) => {
  const { size = 'M', payoff, style, ...otherProps } = props
  const { width, level, margin, letterSpacing, paddingLeft } = SizeConfig[size]
  return (
    <View style={[styles.container, style]} testID="BrandingIdentity.Container" {...otherProps}>
      <Logo width={width} />
      {!!payoff && (
        <Text style={[{ marginTop: margin, letterSpacing, paddingLeft }, styles.text]} level={level}>
          {payoff}
        </Text>
      )}
    </View>
  )
}

export default BrandingIdentity
